import {localizationOptions} from './localizationOptions';
import {translator} from './translator';

translator.setLocale(localizationOptions.locale);
